import React from "react";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { Container } from "./styled-components";
import { Props } from "./types";
import NavigationBarItem from "../NavigationBarItem";
import { BAR, CONTAINER } from "../../constants";

const NavigationBar = ({ items, qaLabel = "" }: Props) => (
  <Container data-qa-label={buildQaLabel([qaLabel, BAR, CONTAINER])}>
    {items.map((item) => (
      <NavigationBarItem
        key={item.href}
        item={item}
        qaLabel={buildQaLabel([qaLabel, BAR])}
      />
    ))}
  </Container>
);

export default NavigationBar;
